export const CONNECTION_STATUS_OPTIONS = [
  { label: 'Черновик', value: 11 },
  { label: 'Ожидает проверки', value: 0 },
  { label: 'Ожидает уточнения', value: 9 },
  { label: 'Принято к рассмотрению', value: 1 },
  { label: 'Выставлен счет', value: 2 },
  { label: 'Выданы техусловия', value: 3 },
  { label: 'Исполнено', value: 4 },
  { label: 'Отклонено', value: 5 },
  { label: 'Передано в ПАО Красноярскэнергосбыт', value: 6 },
  { label: 'Принято в ПАО Красноярскэнергосбыт', value: 7 },
  { label: 'Рассмотрено ПАО Красноярскэнергосбыт', value: 8 },
  { label: 'Договор заключен', value: 10 }
];

export const isConnectionDraft = (status?: number | null) => status === 11;
export const isConnectionEditable = (status?: number | null) =>
  isConnectionDraft(status) || status === 0 || status === 9;

export const CONNECTION_LOAD_NATURE_OPTIONS = [
  { label: 'бытовая', value: 1 },
  { label: 'промышленная', value: 2 },
  { label: 'прочая', value: 3 },
];

export const CONNECTION_RELIABILITY_OPTIONS = [
  { label: 'Категория I', value: 1 },
  { label: 'Категория II', value: 2 },
  { label: 'Категория III', value: 3 },
];

export const CONNECTION_METHOD_OPTIONS = [
  { label: 'Электронно', value: 0 },
  { label: 'Лично', value: 1 },
  { label: 'По почте', value: 2 },
];

export const CONNECTION_REASON_OPTIONS = [
  { label: 'впервые вводимое в эксплуатацию', value: 1 },
  { label: 'увеличение мощности ранее присоединенных энергопринимающих устройств', value: 2 },
  {
    label:
      'изменение точки присоединения, не влекущее пересмотр величины присоединенной мощности, но изменяющее схему внешнего электроснабжения',
    value: 3,
  },
  {
    label:
      'изменение вида производственной деятельности, не влекущее пересмотр величины присоединенной мощности, но изменяющее схему внешнего электроснабжения',
    value: 4,
  },
  { label: 'получение технических условий при смене собственника', value: 5 },
  { label: 'восстановление технических условий', value: 6 },
];

export const getOptionLabel = (
  options: Array<{ label: string; value: number }>,
  value?: number | null,
  fallback = '—',
) => {
  if (value === null || value === undefined) {
    return fallback;
  }
  return options.find((option) => option.value === value)?.label ?? String(value);
};

export const getConnectionStatusLabel = (status?: number | null) => {
  if (status === null || status === undefined) {
    return '—';
  }
  return CONNECTION_STATUS_OPTIONS.find((item) => item.value === status)?.label ?? String(status);
};
